import React from "react"
import { Link } from "react-router-dom"
import Underline from "./Underline"

const Showcase = () => {
  return (
    <section className="showcase px-5">
      <div className="overlay flex flex-col items-center justify-center text-white">
        <div className="text-center bg-white p-5 rounded-lg">
          <h1 className="font-semibold text-4xl text-gray-900 mb-2 md:text-5xl lg:text-6xl 2xl:text-7xl">
            Swadakta Security
          </h1>
          <Underline />
          {/* <p className="text-md md:text-xl">
          All your security needs in one place!
        </p> */}
          <div className="mt-7">
            <Link
              to="/services"
              className="text-md font-bold tracking-wide transition-all duration-500 text-white bg-green-500 py-2 px-6 mt-3 rounded border-2 border-green-500 hover:bg-transparent hover:text-gray-900"
            >
              Services
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Showcase
